import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { ExternalSharesPayload, ExternalSharesResponse } from './external-shares.types';

// ✅ implementado
export async function externalSharesService({ query: { silobagId } }: ExternalSharesPayload) {
  const endpoint = `${ENDPOINT.SILO_PERMISSION}/${silobagId}/external-shares` as ENDPOINT;
  const { response, data } = await BACKEND.get<ExternalSharesResponse>(endpoint);

  return {
    response,
    summary: data,
  };
}
